export default {
  address: 'Adresse',
  contact: 'Contact',
  terms: "Conditions d'utilisation",
  privacy_policy: 'Politique de confidentialité',
  impressum: 'Mentions légales',
  cookie_policy: 'Politique de cookies',
  cookie_settings: 'Paramètres des cookies',
};
